var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.alertDialog.visible,"color":_vm.alertDialog.type,"outlined":"","centered":"","transition":"fade-transition","multi-line":true}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.alertDialog.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }